module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljg0NzAxIDBMOS4wNjMyOCAzLjEzNTA1TDUuOTI4MTMgNi4yNzAxTDIuNzkzMSA3LjA1Mzk2TDUuMzc0MDIgOS42MzQ5MUwwLjExNzE4OCAxNC44OTE4TDEuMjI1MzkgMTZMNi40ODIyMyAxMC43NDMxTDkuMDYzMjggMTMuMzI0MUw5Ljg0NzAxIDEwLjE4OUwxMi45ODIgNy4wNTM5NkwxNi4xMTcyIDYuMjcwMUw5Ljg0NzAxIDBaIiBmaWxsPSIjQ0ZDRkNGIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/bookmarks/pin-inactive.svg
// module id = zeny
// module chunks = 1